import ConvertSDK from '@convertcom/js-sdk'
import { getIsDevelopment } from '@/utils/app'

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig()
  const isDevelopment = getIsDevelopment(runtimeConfig.public)
  const isLocal = process.env.IS_LOCAL === 'true'

  const sdkKey = runtimeConfig.public.CONVERT_SDK_KEY

  if (!sdkKey) {
    // If there is no SDK key configured, provide a null SDK so consumers can no-op safely
    nuxtApp.provide('convertSdk', null)
    return
  }

  const csdk = ((ConvertSDK as any).default || ConvertSDK) as typeof ConvertSDK

  const sdk = new csdk({
    sdkKey,
    dataRefreshInterval: isDevelopment ? 1000 : 300000,
    environment: isDevelopment ? 'staging' : 'production',
    logger: {
      logLevel: isLocal ? 1 : 4
    }
  })

  void sdk.onReady()

  nuxtApp.provide('convertSdk', sdk)
})
